import loadable from '@wix/yoshi-flow-editor/loadable';

export const MediaPage = loadable(
  () => import(/* webpackChunkName: "MediaPage" */ './MediaPage'),
  {
    resolveComponent: (component) => component.MediaPage,
  },
);
